/**
 * AI Batch Node Defaults
 */
export const defaults = {
  inputData: '={{ $json }}',
  systemPrompt: 'You are a helpful AI assistant.',
  userPromptTemplate: '{{item}}',
  testMode: 'full',
  maxTokens: 4096,
  temperature: 0.7
};
